import React from 'react'

import { PageContentProps } from './PageContent.types'
import usePageContext from '../Page/usePageContext'

const PageContent: React.FC<PageContentProps> = ({ children }) => {
    const { pageHeaderHeight } = usePageContext()

    const style = {
        height: `calc(100vh - ${pageHeaderHeight}px)`,
    }

    return (
        <div style={style} data-testid='PageContent' className='r-pagecontent-container'>
            {children}
        </div>
    )
}

export default PageContent
